import { FC, Ref } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';
import { selectLeasingPlanPrice } from '@telialt/utils/src/eshopSelectors';
import { formatCurrencyWithoutZeroDecimals } from '@telialt/utils/src/helpers';

import { ProductTotalAndOldPrice } from './ProductTotalAndOldPrice';
import { PriceBig, PriceContainer } from './TopPrice.styles';

type Props = {
    ref: Ref<HTMLElement>;
};

export const PriceWithMonthlyPayment: FC<Props> = ({ ref }) => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const leasingPlanPrice = selectLeasingPlanPrice(cart);
    const defaultPeriod = t['eshop.product_page.price_default_period'];

    return (
        <PriceContainer data-test={ESHOP_TEST_ID.PRICE_WITH_MONTHLY_PAYMENT} ref={ref as Ref<HTMLDivElement>}>
            {Boolean(leasingPlanPrice?.formattedValue) && (
                <div
                    aria-label={`${formatCurrencyWithoutZeroDecimals(leasingPlanPrice?.value)} ${t['eshop.product_page.monthly_price_unit_accessible']}`}
                >
                    <span aria-hidden={true}>
                        <PriceBig>{formatCurrencyWithoutZeroDecimals(leasingPlanPrice?.value)}</PriceBig>
                        &nbsp;{`${leasingPlanPrice?.currency}/${leasingPlanPrice?.period || defaultPeriod}`}
                    </span>
                </div>
            )}
            <ProductTotalAndOldPrice hasMonthlyPrice={true} />
        </PriceContainer>
    );
};
